import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { axios } from '../../../lib'

export type NfeResponse = {
  nfeId: number
  nfeName: string
  unityId: string
  total: number
  date: string
}

const fetcher = (id?: string) => {
  return axios.get<NfeResponse[]>(`orders/${id}/nfs`)
}

export function useDownloadOrderNFEs(id?: string) {
  return useQuery(['ordersNfe', id], () => fetcher(id), {
    enabled: !!id,
    onError: () =>
      toast.error('Não foi possível carregar as notas fiscais', {
        toastId: 'orderNfe'
      })
  })
}
